import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  updateReady: null,
  view: null,
  modalProps: {},
  drawerProps: {},
  drawerUtils: {},
  alertView: null,
  alertProps: {},
  automationLegend: false,
  autoInput: false,
  activeSidenav: false,
  spiffyOpen: false,
  universalErrorModal: null,
  renderPopover: null,
  popoverTarget: null,
  popoverProps: null,
  isPopoverRemoving: false,

  generalOptions: {
    tourRunning: false,
    userWelcomeActive: null,
    travelQuestionnaireActive: false,
    travelQuestionnaireStartingPage: 'DESTINATION_CONFIDENCE',
  },
}

const appSlice = createSlice({
  name: 'app',
  initialState,
  reducers: {
    setGeneralOptions: (state, action) => {
      state.generalOptions = { ...state.generalOptions, ...action.payload }
    },
    clearGeneralOptions: state => {
      state.generalOptions = initialState.generalOptions
    },
    setUpdateReady: (state, action) => {
      state.updateReady = action.payload
    },
    appStateToggle: (state, action) => {
      state[action.payload.state] = !state[action.payload.state]
    },
    appStateOn: (state, action) => {
      state[action.payload.state] = true
    },
    appStateOff: (state, action) => {
      state[action.payload.state] = false
    },
    openModal: (state, action) => {
      state.view = action.payload.view
      state.isModalOpen = true
      state.modalProps = action.payload.modalProps || {}
      state.modalOpen = true
    },
    closeModal: (state, action) => {
      state.view = null
      state.isModalOpen = false
      state.modalProps = {}
      state.modalOpen = false
    },
    openDrawer: (state, action) => {
      state.drawerView = action.payload.drawerView
      state.isDrawerOpen = true
      state.drawerProps = action.payload.drawerProps || {}
      state.drawerOpen = true
      state.drawerUtils = {}
    },
    closeDrawer: (state, action) => {
      state.drawerView = null
      state.isDrawerOpen = false
      state.drawerProps = {}
      state.drawerOpen = false
      state.drawerUtils = {}
    },
    setDrawerUtils: (state, action) => {
      state.drawerUtils = action.payload
    },
    openErrorModal: (state, action) => {
      state.view = null
      state.modalProps = {}
      state.universalErrorModal = action.payload
      state.isModalOpen = true
      state.modalOpen = true
    },
    closeErrorModal: (state, action) => {
      state.universalErrorModal = null
      state.isModalOpen = false
      state.modalOpen = false
    },
    openAlert: (state, action) => {
      state.alertView = action.payload.alertView
      state.isAlertOpen = true
      state.alertProps = action.payload.alertProps || {}
      state.alertOpen = true
    },
    closeAlert: (state, action) => {
      state.alertView = null
      state.isAlertOpen = false
      state.alertProps = {}
      state.alertOpen = false
    },
    openSidenav: state => {
      state.activeSidenav = true
    },
    closeSidenav: state => {
      state.activeSidenav = false
    },
    openPopover: (state, action) => {
      state.renderPopover = action.payload.renderPopover
      state.popoverTarget = action.payload.popoverTarget
      state.popoverProps = action.payload.popoverProps
      state.isPopoverRemoving = false
    },
    closePopover: state => {
      state.isPopoverRemoving = true
    },
    removePopover: (state, action) => {
      state.renderPopover = null
      state.popoverTarget = null
      state.popoverProps = null
      state.isPopoverRemoving = false
    },
    openChat: (state, action) => {
      state.spiffyOpen = true
    },
    closeChat: (state, action) => {
      state.spiffyOpen = false
    },
    openToast: (state, action) => {
      state.toastView = action.payload.view
      state.toastProps = action.payload.toastProps || {}
      state.toastOpen = true
    },
    closeToast: state => {
      state.toastOpen = false
    },
    removeToastProps: state => {
      state.toastView = null
      state.toastProps = {}
    },
    openAutomationLegend: state => {
      state.automationLegend = true
    },
    closeAutomationLegend: state => {
      state.automationLegend = close
    },
    toggleAutoInput: state => {
      state.autoInput = !state.autoInput
    },
  },
})

export const {
  setGeneralOptions,
  clearGeneralOptions,
  setUpdateReady,
  appStateToggle,
  appStateOn,
  appStateOff,
  openModal,
  closeModal,
  openDrawer,
  closeDrawer,
  setDrawerUtils,
  openErrorModal,
  closeErrorModal,
  openAlert,
  closeAlert,
  openSidenav,
  closeSidenav,
  openPopover,
  closePopover,
  removePopover,
  openChat,
  closeChat,
  openToast,
  closeToast,
  removeToastProps,
  openAutomationLegend,
  closeAutomationLegend,
  toggleAutoInput,
} = appSlice.actions

export default appSlice.reducer
